// import "../../../src/App.css";
import Profile from "../../../components/Profile/Profile";
import AddProfile from "../../../components/AddProfile/AddProfile"; 
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import EmployeeList from "../../../components/EmployeeList/EmployeeList";
import React, { useState, useEffect } from "react";
import axios from "axios";
import MasterTopButtons from  "../../../components/MasterTopButtons/MasterTopButtons";
import Wrapper from "../../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PaginationLink from "../../../components/Pagination/Pagination";
import ExpList from "../../../components/Expense/ExpList";
import Petcratelists from "../../../components/Petcratelists/Petcratelists";
import MicrochipList from "../../../components/MicrochipList/MicrochipList";

function MicrochipListMain() {
  const [userDetailResponse, setUserDetailResponse] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState();
  const baseAPI = process.env.REACT_APP_API_URL;
  const title = "Add Microchip";
  const heading = "";

  // function tokenStorage(){
  //   const storedToken = JSON.parse(localStorage.getItem("token"));
  //   //console.log(storedToken);

  //   if (storedToken) {
  //     axios
  //       .get(`${baseAPI}adminget/GETEmployee?employeeID=`, {
  //         headers: {
  //           Authorization: `Bearer ${storedToken}`,
  //         },
  //       })
  //       .then((response) => {
  //         //console.log(response.data.data);
  //         setUserDetailResponse(response.data.data);
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching user detail:", error);
  //       });
  //   }

  //   if (openAddProfile) {
  //     setOpenProfile(false);
  //   }
  //   else if (openProfile) {
  //     setOpenAddProfile(false);
  //   }
  // };

  // useEffect(() => {
  //   tokenStorage();

  // }, [successMessage, openAddProfile, setOpenProfile, openProfile, setOpenAddProfile]);

  //console.log(userDetailResponse);
  // const GetId = (param) => {
  //   setSelectedEmployeeId(param);

  // };
  const Wrapper = ({ children }) => <div className="Wrapper">{children}</div>;

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Expense| <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Operations</span> {" "}
                  <span style={{ fontSize: "20px" }}>&gt; Expense</span>
                </h1>
              </div>
              <div style={{ width: "8rem" }}>
                <select className="form-control" name="country">
                  <option value="0">INDIA </option>
                  <option value="1">DUBAI </option>
                </select>
              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
                <MasterTopButtons
                  title={title}
                  heading={heading}
                  setOpenAddProfile={setOpenAddProfile}
                  openAddProfile={openAddProfile}
                  setOpenProfile = {setOpenProfile}
                  headingStyle={{ backgroundColor: "blue" }}
                  />
<MicrochipList/>                {/* <EmployeeList
                  userDetailResponse={userDetailResponse}
                  setOpenProfile={setOpenProfile}
                  openProfile={openProfile}
                  GetId={(param) => GetId(param)}
                  openAddProfile = {openAddProfile} 
                  setOpenAddProfile = {setOpenAddProfile}
                /> */}
                <PaginationLink />
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MicrochipListMain;
